import { Checkbox, Form, Input, InputNumber, Modal, Select } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { administratorsAddAction } from '~Administrators/actions';
import ActiveStatusEnum from '~Api/Administrator/ActiveStatusEnum';
import IAdministrator from '~Api/Administrator/IAdministrator';
import RoleEnum from '~Api/Administrator/RoleEnum';
import './administrators.less';
import { currencyFormatter } from '~utilities/formatters';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface IState {
    dealMaximumValue: number;
    dealMinimumValue: number;
    email: string;
    leadsAutoAssign: boolean;
    name: string;
    phone: string;
    photoUrl: string;
    title: string;
}

interface IProps {
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsDispatch {
    add: (administrator: IAdministrator) => void;
}

type Props = IProps & IPropsDispatch;

class AddModal extends React.Component<Props, IState> {
    public state: IState = {
        dealMaximumValue: null,
        dealMinimumValue: null,
        email: null,
        leadsAutoAssign: false,
        name: null,
        phone: null,
        photoUrl: null,
        title: null,
    };

    constructor(props: Props) {
        super(props);

        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangePhotoUrl = this.onChangePhotoUrl.bind(this);
        this.onChangeTitle = this.onChangeTitle.bind(this);
        this.onChangeDealMaximumValue = this.onChangeDealMaximumValue.bind(this);
        this.onChangeDealMinimumValue = this.onChangeDealMinimumValue.bind(this);
        this.onChangeAutoAssign = this.onChangeAutoAssign.bind(this);

        this.onClickOk = this.onClickOk.bind(this);
    }

    public render(): JSX.Element {
        const { isOpen } = this.props;
        const {
            dealMaximumValue,
            dealMinimumValue,
            email,
            leadsAutoAssign,
            name,
            phone,
            photoUrl,
            title,
        } = this.state;

        const dealMinimumBlock: JSX.Element = leadsAutoAssign && (
            <Form.Item label='Deal Minimum' className='deal-minimum-value' extra={currencyFormatter.format(dealMinimumValue)}>
                <InputNumber addonBefore='$' onChange={this.onChangeDealMinimumValue} value={dealMinimumValue} />
            </Form.Item>
        );

        const dealMaximumBlock: JSX.Element = leadsAutoAssign && (
            <Form.Item label='Deal Maximum' className='deal-maximum-value' extra={currencyFormatter.format(dealMaximumValue)}>
                <InputNumber addonBefore='$' onChange={this.onChangeDealMaximumValue} value={dealMaximumValue} />
            </Form.Item>
        );

        return (
            <Modal
                onCancel={this.props.onCancel}
                onOk={this.onClickOk}
                open={isOpen}
                title='Add Administrator'
                wrapClassName='administrator-add-modal'
            >
                <Form.Item label='Name' className='name'>
                    <Input onChange={this.onChangeName} value={name} />
                </Form.Item>
                <Form.Item label='Email' className='email'>
                    <Input onChange={this.onChangeEmail} value={email} />
                </Form.Item>
                <Form.Item label='Phone' className='phone'>
                    <Input onChange={this.onChangePhone} value={phone} />
                </Form.Item>
                <Form.Item label='Photo URL' className='photo-url'>
                    <Input onChange={this.onChangePhotoUrl} value={photoUrl} />
                </Form.Item>
                <Form.Item label='Title' className='title'>
                    <Input onChange={this.onChangeTitle} value={title} />
                </Form.Item>
                <Form.Item label='Auto Assign Leads'>
                    <Checkbox onChange={this.onChangeAutoAssign} checked={leadsAutoAssign} />
                </Form.Item>
                {dealMinimumBlock}
                {dealMaximumBlock}
            </Modal>
        );
    }

    private onChangeAutoAssign(event: CheckboxChangeEvent): void {
        this.setState({
            leadsAutoAssign: event.target.checked,
        });
    }

    private onChangeName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            name: event.target.value,
        });
    }

    private onChangeEmail(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            email: event.target.value,
        });
    }

    private onChangePhone(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            phone: event.target.value,
        });
    }

    private onChangePhotoUrl(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            photoUrl: event.target.value,
        });
    }

    private onChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            title: event.target.value,
        });
    }

    private onChangeDealMaximumValue(value: number): void {
        this.setState({
            dealMaximumValue: value,
        });
    }

    private onChangeDealMinimumValue(value: number): void {
        this.setState({
            dealMinimumValue: value,
        });
    }

    private onClickOk(): void {
        const {
            leadsAutoAssign,
            dealMaximumValue,
            dealMinimumValue,
            email,
            name,
            phone,
            photoUrl,
            title,
        } = this.state;

        this.props.onCancel();

        const administrator: IAdministrator = {
            dealMaximumValue,
            dealMinimumValue,
            email,
            hubspotOwnerId: null,
            leadsAutoAssign,
            name,
            permissions: [],
            phone,
            photoUrl,
            role: null,
            status: ActiveStatusEnum.Active,
            title,
        };

        this.props.add(administrator);
    }
}

function mapDispatchToProps(dispatch: Dispatch): IPropsDispatch {
    return {
        add: (administrator: IAdministrator) => dispatch(administratorsAddAction(administrator)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(AddModal);
